export { default } from './InternalTagTypeAhead';
